import { useState } from 'react'
import ProjectInfo from './ProjectInfo'
import FeaturesTask from './FeaturesTask'
import TaskAnalysis from './TaskAnalysis'
import TeamComposition from './TeamComposition'
import Worklog from './Worklog'

const ProjectDetailsCards = ({projectId, projectName}) => {
    
    const [dateFilter, setDateFilter] = useState({});

    return (
        <div className='p-3 w100' style={{ backgroundColor: "var(--bg-light)" }}>
            <div className='row w100'>
                <div className='col-md-6 col-12 mb-3'>
                    <div className='p-2 h-100' style={{ borderRadius: "10px", backgroundColor: "var(--bg-color)", border: "1px solid var(--grid-border-color)" }}>
                        <ProjectInfo projectId={projectId} />
                    </div>
                </div>
                <div className='col-md-6 col-12 mb-3'>
                    <div className='p-2 h-100' style={{ borderRadius: "10px", backgroundColor: "var(--bg-color)", border: "1px solid var(--grid-border-color)" }}>
                        <TeamComposition projectId={projectId} projectName={projectName}/>
                    </div>
                </div>
                <div className='col-md-6 col-12 mb-3'>
                    <div className='p-2 h-100' style={{ borderRadius: "10px", backgroundColor: "var(--bg-color)", border: "1px solid var(--grid-border-color)" }}>
                        <FeaturesTask isFeature={true} projectId={projectId} dateFilter={dateFilter} setDateFilter={setDateFilter}/>
                    </div>
                </div>
                <div className='col-md-6 col-12 mb-3'>
                    <div className='p-2 h-100' style={{ borderRadius: "10px", backgroundColor: "var(--bg-color)", border: "1px solid var(--grid-border-color)" }}>
                        <FeaturesTask isFeature={false} projectId={projectId} dateFilter={dateFilter} setDateFilter={setDateFilter}/>
                    </div>
                </div>
                <div className='col-md-12 col-12 mb-3'>
                    <div className='p-2 h-100' style={{ borderRadius: "10px", backgroundColor: "var(--bg-color)", border: "1px solid var(--grid-border-color)" }}>
                        <TaskAnalysis projectId={projectId} />
                    </div>
                </div>
                <div className='col-md-12 col-12 mb-3'>
                    <div className='p-2 h-100' style={{ borderRadius: "10px", backgroundColor: "var(--bg-color)", border: "1px solid var(--grid-border-color)" }}>
                        <Worklog projectId={projectId} />
                    </div>
                </div> 
            </div>
        </div>
    )
}

export default ProjectDetailsCards